import CookieConsentServiceInstance from '@services/CookieConsentService';
import { CookieCategory } from '@shared-types/optanon.types';
import { getCountry } from '@utilities/country';
import { loadFromAPIs } from '@utilities/fetch';
import { Trace } from '@utilities/logging';
import { uefaBaseUrl } from '@utilities/WindowContext';

export type GeoTargetingIncluderPluginOptions = {
  allowedUrl: string;
  disallowedUrl: string;
  allowedCountries?: string[];
  disallowedCountries?: string[];
  checkCookieConsent: boolean;
};

const defaults: GeoTargetingIncluderPluginOptions = {
  allowedUrl: '',
  disallowedUrl: '',
  allowedCountries: null,
  disallowedCountries: null,
  checkCookieConsent: false,
};

export default class GeoTargetingIncluderPlugin {
  options: GeoTargetingIncluderPluginOptions;
  dom: HTMLElement;

  constructor(e: HTMLElement, o: any) {
    this.options = {
      ...defaults,
      ...o,
    };

    this.dom = e;
  }

  async init() {
    if (this.options.checkCookieConsent) {
      await CookieConsentServiceInstance.waitForCookiesAccepted(CookieCategory.ESSENTIAL);
    }

    const country = await getCountry();

    const cc = country?.countryCodeShort?.toUpperCase() || 'EN';
    const fcc = country?.fifaCountryCode?.toUpperCase() || 'ENG';

    const url = this._getUrl(cc, fcc);
    await this._loadContent(url);
  }

  detach() {
    Trace('ok');
  }

  async _loadContent(url: string) {
    if (!url) return;

    const html = await loadFromAPIs(url, {}, { responseType: 'text', apiUrl: uefaBaseUrl });

    this.dom.innerHTML = html;
    this.dom.classList.remove('hidden');
  }

  _getUrl(cc: string, fcc: string) {
    const placeholder = '{country}';
    const placeholder2 = '{countrycode}';

    let url = '';

    if (!this.options.allowedCountries || this.options.allowedCountries.includes(cc)) {
      url = this.options.allowedUrl;
    }

    if (this.options?.disallowedCountries?.includes(cc)) {
      url = this.options.disallowedUrl;
    }

    if (!url || url === window.location.pathname) return '';

    return url.replace(placeholder, cc).replace(placeholder2, fcc);
  }
}
